.tag-list-select__container {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;

  gap: 8px;
}

.tag-list-select__container .tag-list-select__title {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
}

.tag-list-select__container .tag-list-select__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  white-space: pre-wrap;
}

.tag-list-select__container .tag-list-select__options {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 8px;
}

.tag-list-select__container .tag-list-select__option {
  position: relative;
  width: 19%;
  min-width: 100px;

  cursor: pointer;

  height: 72px;
  padding: 12px 12px 12px 16px;
  border-radius: 8px;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  background-color: white;
  border: 1px solid #DADADA;

  &:hover {
    background: rgba(#22BDFF, 0.5);
  }
}

.tag-list-select__container .tag-list-select__option-check {
  position: absolute;
  right: 0;
  top: 0;

  font-size: 24px;

  transform: translate(30%, -30%);

  border-radius: 50%;

  color: white;
  background-color: #272832;
}

.tag-list-select__container .tag-list-select__option-selected {
  background: #22BDFF;
  border-color: #22BDFF;

  &:hover {
    background: #22BDFF;
    border-color: #22BDFF;
  }
}

.tag-list-select__container .tag-list-select__option-disabled {
  filter: grayscale(1);
  cursor: not-allowed;
}

.tag-list-select__container .tag-list-select__option-warning {
  border-color: var(--color-warning);
}

.tag-list-select__container .tag-list-select__option-error {
  border-color: var(--color-danger-medium);
}

@media screen and (width <=640px) {
  .tag-list-select__container .tag-list-select__options {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .tag-list-select__container .tag-list-select__option {
    width: unset;
    overflow-wrap: anywhere;
    min-height: 72px;
    height: unset;
  }
}